import { useEffect, useState } from 'react';
import {
  useApi,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import CircularProgress from '@material-ui/core/CircularProgress';
import { createFormField } from '@backstage/plugin-scaffolder-react/alpha';

type Region = { name: string; isHome: boolean };

export function OciRegionPickerComponent({
  onChange,
  rawErrors,
  formData,
}: any) {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [regions, setRegions] = useState<Region[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    discoveryApi.getBaseUrl('infrastructure').then(baseUrl => {
      fetchApi
        .fetch(`${baseUrl}/oci/regions`)
        .then(r => r.json())
        .then(data => {
          if (data.error) {
            setError(
              typeof data.error === 'string'
                ? data.error
                : data.error?.message ?? 'Failed to load OCI regions',
            );
          } else {
            const list: Region[] = data.regions ?? [];
            setRegions(list);
            if (!formData) {
              const home = list.find(r => r.isHome);
              if (home) onChange(home.name);
            }
          }
        })
        .catch(() => setError('Failed to load OCI regions'))
        .finally(() => setLoading(false));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <CircularProgress size={20} />;

  return (
    <FormControl fullWidth error={!!rawErrors?.length || !!error}>
      <InputLabel>OCI Region</InputLabel>
      <Select
        value={formData ?? ''}
        onChange={e => onChange(e.target.value as string)}
      >
        {regions.map(r => (
          <MenuItem key={r.name} value={r.name}>
            {r.name}
            {r.isHome ? ' (home)' : ''}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}

export const OciRegionPickerField = createFormField({
  name: 'OciRegionPicker',
  component: OciRegionPickerComponent,
});
